<!-- <div class="">
    <mat-dialog-content class="">
        <div class="assessment_py-20 font-14">
            {{ data?.message }}
        </div>
        <div class="font-14">
            <pre *ngIf="data?.caution">{{ data?.caution }}</pre>
        </div>
        <div class="dialog-footer">
            <div class="pop-btns-set pull-right">
                <button class="font-12 color-grey2 assessment_mr-10" (click)="onNoClick()" mat-button>No</button>
                <button mat-button tabindex="1" (click)="onConfirmClick()" class="font-12 bg-blue color-white">
                    Yes
                </button>
            </div>
        </div>
    </mat-dialog-content>
    
</div> -->




<div class="">
    <mat-dialog-content class="account-box" style="overflow: hidden; scroll-behavior: unset;">

        <div class="accont-created-desc" style="margin-bottom:14px;">
            {{ data?.message }}
        </div>

        <div class="dialog-footer">
            <div class="pop-btns-set pull-right">
                <button class="font-12 color-grey2 assessment_mr-10" (click)="onNoClick()" mat-button>No</button>
                <button mat-button tabindex="1" (click)="onConfirmClick()" class="font-12 bg-blue color-white">
                    Yes
                </button>
            </div>
        </div>

        </mat-dialog-content>
        </div> 